<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <el-tabs v-if="catId != null" class="mt10" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="分类" name="cat" v-if="catId != null"></el-tab-pane>
            <el-tab-pane label="分类品牌" name="catBrand" v-if="catId != null && brandId != null"></el-tab-pane>
            <el-tab-pane label="分类品牌型号规格" name="catBrandModelSpec" v-if="catId != null && brandId != null && modelSpec != null"></el-tab-pane>
            <el-tab-pane label="全部" name="all"></el-tab-pane>
        </el-tabs>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox} from '../../app.vues'
    import {loadRetailerDevcGroupList} from '../retailer/asset-comn'
    import {getMerchtAssetNatureMap} from '../index'

    import {getDefaultPageSizes} from '../../app.conf'
    import {openBigImgDlg} from '../comn/dialog'

    import devcDefApi from '../../api/devcDef'

    export default {
        name: 'swb-mercht-devc-def-list-for-select',
        desc: '资产定义选择列表',
        props: {
            catId: {
                type: Number,
                default: null
            },
            brandId: {
                type: Number,
                default: null
            },
            modelSpec: {
                type: String,
                default: null
            },
            assetType: {
                type: Number,
                default: null
            },
            checkBox: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: true
            },
            tempOnly: {
                type: Boolean,
                default: false
            },
            normalized: {
                type: Boolean,
                default: null
            },
            selectIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            exceptDevcDefId: {
                type: Number,
                default: null
            },
            filter: {
                type: Object,
                default: {}
            },
            metaConfKey: {  // 外部指定的列配置
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                confKey: 'swb-mercht-devc-def-list-select',
                theTableHeight: 550,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: true, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                devcDefList: [],
                activeName: 'cat',
                allotLogicTypeList: null,
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                assetTypeMap: getEnumMap('assetType', 'value2text'),
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.allotLogicTypeList = getEnumMap('allotAcntMethod', 'value2text');
            //
            this.multiSelect = this.checkBox;
            this.multiPageSelect = this.checkBox;
            //
            if (!Utils.isNoB(this.catId)) {
                this.activeName = 'cat';
            }
            if (!Utils.isNoB(this.metaConfKey)) {
                this.confKey = this.metaConfKey;
            } else {
                if (this.assetType == 0) {
                    this.confKey = 'swb-mercht-devc-def-list-select';
                } else if (this.assetType == 1) {
                    this.confKey = 'swb-mercht-devc-def-list-select-1';
                } else if (this.assetType == 2) {
                    this.confKey = 'swb-low-cost-def-list-select';
                }
            }
        },
        mounted() {
            //
            this.initResultTable();
            //回显数据处理
            let initChecked = this.selectIds;
            let resultTable = this.$refs.result_table;
            resultTable.setInitChecked(initChecked, true);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onQueryConfigReady: function () {
                this.initAsyncQueryModel();
            },
            initAsyncQueryModel() {
                //
                let self = this;
                // 分类分组
                loadRetailerDevcGroupList(function (dataList) {
                    self.updateQueryModelField('devcGroupId', dataList);
                });
                // 资产属性
                getMerchtAssetNatureMap((merchtAssetNatureList) => {
                    if (merchtAssetNatureList.length > 0) {
                        let dataList = [{'value': null, 'label': '- 全部 -'}];
                        merchtAssetNatureList.forEach(function (item) {
                            let dataInfo = {};
                            dataInfo.value = item.value;
                            dataInfo.label = item.text;
                            dataList.push(dataInfo);
                        });
                        this.updateQueryModelField('assetNature', dataList);
                    }
                });
                //
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                if (!Utils.isNoB(this.normalized)) {
                    query_model_ctrl.updateFields({
                        normalized: {
                            disabled: true,
                            hidden: true
                        }
                    });
                }
                if (!Utils.isNoB(this.assetType)) {
                    query_model_ctrl.updateFields({
                        assetType: {
                            disabled: true,
                            hidden: true
                        }
                    });
                }
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if (!Utils.isNoB(row.imageUrl)) {
                            return '<a href="#"><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>';
                        } else {
                            return '';
                        }
                    },
                    'allotAcntMethod': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.allotLogicTypeList[row.allotAcntMethod] + '</span>';
                    },
                    'normalized': function (row, colName, colValue, rowIndex, colConf) {
                        if (Utils.isTrue(row.normalized)) {
                            return '<span class="font-green">在账资产</span>';
                        } else {
                            return '<span class="font-red">账外设备</span>';
                        }
                    },
                    'assetNature': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.assetNatureMap[row.assetNature] + '</span>';
                    },
                    'assetType': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.assetTypeMap[row.assetType] + '</span>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'imageUrl': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewImage(row.imageUrl);
                    },
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDevcDefList();
            },
            //
            handleClick(tab, event) {
                this.activeName = tab.name;
                this.pageNoChangeHandler(1, this.pageSize);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDevcDefList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            getDevcDefList() {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if (self.activeName == 'cat') {
                    filterItems.catId = self.catId;
                } else if (self.activeName == 'catBrand') {
                    filterItems.catId = self.catId;
                    filterItems.brandId = self.brandId;
                } else if (self.activeName == 'catBrandModelSpec') {
                    filterItems.catId = self.catId;
                    filterItems.brandId = self.brandId;
                    filterItems.modelSpec = self.modelSpec;
                } else if (self.activeName == 'all') {
                    filterItems.catId = null;
                    filterItems.brandId = null;
                }
                if (!Utils.isNoB(self.assetType)) {
                    filterItems.assetType = self.assetType;
                }
                if (!Utils.isNoB(self.normalized)) {
                    filterItems.normalized = self.normalized;
                }
                if (!Utils.isNoB(self.exceptDevcDefId)) {
                    filterItems.exceptDevcDefId = self.exceptDevcDefId;
                }
                if (!Utils.isNoB(self.tempOnly)) {
                    filterItems.tempOnly = self.tempOnly;
                }
                //
                filterItems = Object.assign(filterItems, self.filter || {});
                if (self.activeName == 'all') {
                    filterItems.vendorId = null;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoading = MsgBox.loading();
                devcDefApi.getMerchtDevcDefList(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        self.devcDefList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(self.devcDefList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult: function () {
                let selectList = this.getTableSelection() || [];
                //
                let result = {};
                if (Utils.isTrue(this.required)) {
                    if (selectList.length <= 0) {
                        result.type = 'warn';
                        if (Utils.isTrue(this.checkBox)) {
                            result.message = '请选择至少一个定义！';
                        } else {
                            result.message = '请选择定义！';
                        }
                    } else {
                        result.type = 'info';
                        result.data = selectList;
                    }
                } else {
                    if (!Utils.isTrue(this.checkBox) && selectList.length <= 0) {
                        result.type = 'warn';
                        result.message = '请选择定义！';
                    } else {
                        result.type = 'info';
                        result.data = selectList;
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcDefListForSelect.vue